'use client';

import { ReactNode } from 'react';
import UserContext from '@/main/app/user-context';
import { useAuth } from '@/contexts/auth-context';

/**
 * Bridges the new AuthContext to the original app's UserContext
 * so all original components can access currentUser via useContext(UserContext)
 */
export function UserContextBridge({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();

  return (
    <UserContext.Provider value={{ 
      currentUser: user as any, 
      isInitialized: !isLoading,
      isLoading 
    } as any}>
      {children}
    </UserContext.Provider>
  );
}
